/**
 * soubor se seznamem veškerých graphql dotazů pro kategorie
 */
import gql from 'graphql-tag';

/**
 * vložení kategorie
 */
export const ADD_EDIT_SERVICE = gql`
    mutation AddEditService($serviceID:ID,$categoryID:Int, $langs:[ServiceLangsInput]){
        addEditService(serviceID:$serviceID, categoryID:$categoryID,langs:$langs){
            serviceID
            name
            price
            vat
            lang
        }
    }
`;

/**
 *  Úprava priority kategorie, když se přesouvají položky
 */
export const UPDATE_SERVICE_PRIORITY = gql`
    mutation updateServicePriority($serviceID:ID!,$fromIndex:Int!,$toIndex:Int!) {
        updateServicePriority(serviceID:$serviceID,fromIndex:$fromIndex,toIndex:$toIndex)
    }
`;

/**
 *  Data pro jednu kategorii
 */

export const GET_SERVICE = gql`
    query ServiceWithLangs($serviceID: ID!){
        serviceWithLangs(serviceID:$serviceID){
            serviceID
            langs{
                lang
                name
                price
                vat
                emailText
            }    
        }
        allLanguageMutations(onlyEnabled:true){
            languageID
            title
            suffix
            file
            generateNiceTitle
            langTitle
            decimal
            priority
            main
            currencyTitle
        }
        allVats{
            value
        }

    }
`;

/**
 *  Seznam veškerých kategorií
 */
export const GET_SERVICES = gql`
    query AllServices($lang: String!){
        allServices(lang: $lang){
            serviceID
            name
            price
            vat
            lang
        }
    }
`;

/**
 * Smazání kategorie.
 */
export const DELETE_SERVICES = gql`
    mutation deleteServices($serviceIDs:ID!) {
        deleteServices(serviceIDs:$serviceIDs)
        reindexPriority
    }
`;

/**
 * vyhledání služeb
 */
export const SEACRH_SERVICES = gql`

    query SearchServices($text: String!,$lang:String){
        searchServices(text:$text,lang:$lang){
            name
            serviceID
        }

    }

`;